import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    TabBarDynamicStyleType,
    TabBarScrollStateType
} from "./type";
import type {
    Mutable
} from "../../types";

export const TAB_BAR_MAX_ITEMS = 5;

export const TAB_BAR_MORE_KEY = "__more";

export const TAB_BAR_KEYBOARD_VIEWPORT_RATIO = 0.75;

export const TAB_BAR_INITIAL_SCROLL_STATE: TabBarScrollStateType = {
    isHidden: false,
    anchorOffset: 0
};

const stylesheet = StyleSheet.create({
    list: {
        alignItems: "stretch",
        flexDirection: "row",
        minWidth: 0
    },
    cell: {
        flexDirection: "row",
        flexBasis: 0,
        flexGrow: 1,
        minWidth: 0
    },
    container: {
        width: "100%",
        flexShrink: 0,
        minWidth: 0
    }
});

export const useStyles = ({
    bottomInset,
    isConcealed,
    borders,
    colors,
    spaces
}: TabBarDynamicStyleType) => {
    const styles = {
        container: {
            backgroundColor: colors.content.container.mid,
            paddingBottom: bottomInset + spaces.spacingXs,
            borderTopColor: colors.content.border.subtle,
            borderTopWidth: borders.separator,
            paddingTop: spaces.spacingXs
        } as Mutable<ViewStyle>
    };

    if(isConcealed) {
        styles.container.display = "none";
    }

    return styles;
};
export default stylesheet;
